var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mx-2"},[_c('v-card',{staticClass:"mt-2"},[_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('v-toolbar',{staticClass:"rounded-xl mb-7",attrs:{"flat":""}},[_c('v-toolbar-title',[_c('strong',[_vm._v(_vm._s(_vm.$route.meta.title))])]),_c('v-spacer')],1),_c('UsersDataTable')],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }